module.exports = __webpack_public_path__ + "img/emploisadmin.c81373f1.png";